import type { EditorStickerAsset } from '@/types/editor';

export interface EditorStickerPack {
  id: string;
  name: string;
  description: string;
  accent: string;
  stickers: EditorStickerAsset[];
}

const CREATED_AT = '2026-07-13T00:00:00.000Z';

function sticker(packId: string, id: string, title: string): EditorStickerAsset {
  return {
    id: `pack-${packId}-${id}`,
    title,
    src: `/editor-stickers/${packId}/${id}.png`,
    mimeType: 'image/png',
    createdAt: CREATED_AT,
  };
}

export const STICKER_PACKS: EditorStickerPack[] = [
  {
    id: 'sales-boost',
    name: 'Sales Boost',
    description: 'Скидки, CTA и промо для рекламы',
    accent: 'from-orange-500/25 via-pink-500/15 to-violet-500/20',
    stickers: [
      sticker('sales-boost', 'discount-20', 'Скидка 20%'),
      sticker('sales-boost', 'sale', 'Распродажа'),
      sticker('sales-boost', 'new', 'Новинка'),
      sticker('sales-boost', 'hit', 'Хит'),
      sticker('sales-boost', 'buy', 'Купить'),
      sticker('sales-boost', 'limited', 'Limited'),
      sticker('sales-boost', 'one-plus-one', 'Один плюс один'),
      sticker('sales-boost', 'gift', 'Подарок'),
      sticker('sales-boost', 'best-choice', 'Лучший выбор'),
      sticker('sales-boost', 'today', 'Только сегодня'),
      sticker('sales-boost', 'promocode', 'Промокод'),
    ],
  },
  {
    id: 'creator-pop',
    name: 'Creator Pop',
    description: 'Яркие акценты для шортсов',
    accent: 'from-fuchsia-500/30 via-violet-500/15 to-cyan-400/20',
    stickers: [
      sticker('creator-pop', 'lightning', 'Молния'),
      sticker('creator-pop', 'flame', 'Огонь'),
      sticker('creator-pop', 'starburst', 'Вспышка'),
      sticker('creator-pop', 'crown', 'Корона'),
      sticker('creator-pop', 'rocket', 'Ракета'),
      sticker('creator-pop', 'heart', 'Сердце'),
    ],
  },
  {
    id: 'social-reactions',
    name: 'Social Reactions',
    description: 'Реакции, эмоции и вовлечение',
    accent: 'from-amber-400/25 via-pink-500/15 to-violet-500/25',
    stickers: [
      sticker('social-reactions', 'wow', 'Вау'),
      sticker('social-reactions', 'thumbs-up', 'Лайк'),
      sticker('social-reactions', 'party', 'Праздник'),
      sticker('social-reactions', 'laugh', 'Смех'),
      sticker('social-reactions', 'exclamation', 'Важно'),
      sticker('social-reactions', 'camera', 'Камера'),
    ],
  },
];
